<template>
  <template v-if="moduleEnCours">
    <div class="element__detail">
      <div class="flex flex-gap-1">
        <BasicText
          size="h4"
          weight="bold"
        >
          #{{ activeModuleIndex! + 1 }} Organisme de formation {{ getModuleLabel(moduleEnCours.typeModule!) }}
        </BasicText>
        <BasicIcon
          @click="définirModuleEnCours(null)"
          class="element__detail--hide"
          name="close"
        />
      </div>
      <BasicButton
        v-if="!readonly"
        variant="outlined"
        label="Supprimer"
        icon-name="minus-square"
        @click="supprimerModule(activeModuleIndex!)"
        class="element__detail--delete"
        :disabled="isDisableDeleteModule"
      />
    </div>
    <RechercheOrganisme />
    <InformationsModule />
    <AdresseModule v-if="estDossier"/>
    <CoutFormation v-if="estDossier"/>
  </template>
</template>

<script setup lang="ts">
  import AdresseModule from '@/features/interface/demande/cxpi/steps/formation/sections/adresse/adresseModule.vue'
import RechercheOrganisme from '@/features/interface/demande/cxpi/steps/formation/sections/recherche/RechercheOrganismeSection.vue'
import { DEMANDE_STORE } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { CXPI_MODULES_ACTIONS } from '../../useModuleActions'
import CoutFormation from '../frais/CoutFormation.vue'
import InformationsModule from '../informations/InformationsModule.vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { readonly, estDossier } = storeToRefs(store)
  const { activeModuleIndex, supprimerModule, définirModuleEnCours, getModuleLabel, moduleEnCours } =
    inject(CXPI_MODULES_ACTIONS)!

  const isDisableDeleteModule = computed(() => estDossier.value && moduleEnCours.value?.typeModule === 'Externe')
</script>
